import { Button, Stack, TextField } from "@mui/material";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import StelModal from "components/StelModal";

export default function CopyModal(props) {
  const { text, open, onClose } = props;
  const textInputRef = useRef(null);

  const selectTextInput = () => {
    const input = textInputRef.current;
    input.focus();
    input.select();
  };

  return (
    <StelModal
      open={open}
      onClose={onClose}
      title="Copy to Clipboard"
      width={500}
    >
      <TextField
        inputRef={textInputRef}
        value={text}
        fullWidth
        multiline
        maxRows={10}
      />
      <Stack direction="row" justifyContent="flex-end" sx={{ mt: "10px" }}>
        <Button onClick={selectTextInput} variant="contained">
          Select All
        </Button>
      </Stack>
    </StelModal>
  );
}

CopyModal.propTypes = {
  text: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
